const worksVue = [
  {
    title: 'Bus App',
    accomplishment: ['Built with Vue 3', 'Call Open API', 'Display with Leaflet map'],
    img: 'Vue-BusApp-desktop.png',
    mobileImg: 'Vue-BusApp-mobile.png',
    link: 'https://weichieh123.github.io/Open-API/#/bus-line',
    website: 'https://weichieh123.github.io/Open-API/#/bus-line',
    github: 'https://github.com/weichieh123/Open-API',
    tags: ['Vue3', 'Open API', 'Axios', 'Leaflet'],
    rwd: true,
    content: '使用Vue3架構，串接Open API，實現公車路線查詢之功能。',
    isLong: false,
    isFlip: false,
  },
  {
    title: 'F.H. Museum',
    accomplishment: ['Built with Vue 3', 'Scss management', 'Responsive Web Design'],
    img: 'Vue-FransHals-desktop.png',
    mobileImg: 'Vue-FransHals-mobile.png',
    link: 'https://weichieh123.github.io/Vue-FransHalsMuseum/',
    website: 'https://weichieh123.github.io/Vue-FransHalsMuseum/',
    github: 'https://github.com/weichieh123/Vue-FransHalsMuseum',
    tags: ['Vue3', 'Layout', 'Scss', 'RWD'],
    rwd: true,
    content: '使用Vue3架構，以FransHals Museum網站為參考做切版練習。',
    isLong: true,
    isFlip: false,
  },
  {
    title: 'Covid19 App',
    accomplishment: ['Built with Vue 3', 'Call Open data', 'Display with Leaflet map'],
    img: 'Vue-Covid19TestApp-desktop.png',
    mobileImg: 'Vue-Covid19TestApp-mobile.png',
    link: 'https://weichieh123.github.io/covid19-test-app/',
    website: 'https://weichieh123.github.io/covid19-test-app/',
    github: 'https://github.com/weichieh123/covid19-test-app',
    tags: ['Vue3', 'Open Data', 'Axios', 'Leaflet'],
    rwd: true,
    content: '使用Vue3架構，串接下載衛服部之開放式資料，實現快篩試劑庫存查詢之功能。',
    isLong: true,
    isFlip: false,
  },
  {
    title: 'Todo App',
    accomplishment: ['Built with Vue 2', 'CRUD'],
    img: 'Vue-TodoApp-desktop.png',
    mobileImg: '',
    link: 'https://weichieh123.github.io/Vue-TodoApp/',
    website: 'https://weichieh123.github.io/Vue-TodoApp/',
    github: 'https://github.com/weichieh123/Vue-TodoApp',
    tags: ['Vue2'],
    rwd: false,
    content: '使用Vue2架構，實現新增、修改、刪除、查詢之功能。',
    isFlip: false,
  },
];

export default worksVue;
